/* BETTER³ KOKON Shop — Skript. Dieses Paket ist die Quelle der Wahrheit.
   In einer Funktion gekapselt, damit keine globalen Namen ins Theme lecken.
   Texte kommen aus <script id="kokon-i18n"> (Liquid: locales/*.json, "kokon.js.*").
   Einbau-Hook: window.kokonUebergabe(daten) — definiert in sections/kokon-shop.liquid. */
(function () {
'use strict';

/* =====================================================================
   BETTER³ Verkaufsseite — Konfigurator mit erklärender Live-Bühne.
   Keine Scroll-Animationen mehr: die Seite ist auf Konversion gebaut,
   alle Bewegung liegt in CSS-Transitions der Bühne.
   ===================================================================== */

const reduzierteBewegung =
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const klemme = (wert, min, max) => Math.min(max, Math.max(min, wert));

/* ---------------------------------------------------------------------
   Texte (DE/EN/IT) — aus dem Theme geliefert, Fallback deutsch
   --------------------------------------------------------------------- */
const I18N = (function () {
  try {
    const el = document.getElementById('kokon-i18n');
    return el ? JSON.parse(el.textContent) : {};
  } catch (e) { console.warn('[KOKON] i18n nicht lesbar', e); return {}; }
})();
function t(key, vars) {
  let s = I18N[key];
  if (s == null) { console.warn('[KOKON] Übersetzung fehlt:', key); s = key; }
  if (vars) s = s.replace(/\{(\w+)\}/g, (_, n) => (vars[n] != null ? vars[n] : ''));
  return s;
}
const SPRACHE = (document.documentElement.lang || 'de').slice(0, 2);
/* it-IT laesst bei 4 Stellen den Tausenderpunkt weg (1790) — Italienisch nutzt dieselbe Schreibweise wie Deutsch (1.790), daher de-DE */
const ZAHL_LOCALE = { de: 'de-DE', en: 'en-GB', it: 'de-DE' }[SPRACHE] || 'de-DE';

/* ---------------------------------------------------------------------
   Preise und Größen.
   Preisstruktur laut Rückmeldung BETTER³ (Rüdiger, 2026-09-02):
   Oberbett oder Unterbett einzeln 990 · KOKON Single 1.790 · KOKON
   Partner 2.990 · Komplett Single 3.280 · Komplett Partner 3.990 ·
   Regenerationssystem 1.990 · Zusatz-Fastentasche 35. "Komplett" =
   KOKON-Set plus Regenerationssystem (Bundle-Preis). Beim Partner-Set
   ist der Preis unabhängig von 1 oder 2 Decken bzw. Matratzen.
   Die Shopify-Varianten (produkt-kokon.csv) müssen dieselben Beträge
   tragen — der Hook in der Section prüft das beim Klick.
   --------------------------------------------------------------------- */
const PREISE = {
  singleSet: 1790,          // KOKON für 1 Person: Zudecke + Auflage + 1 Fastentasche
  partnerSet: 2990,         // KOKON für 2 Personen: alle Kombinationen, 2 Fastentaschen
  komplettSingle: 3280,     // Anti-Stress-Zimmer komplett: KOKON Single + Regenerationssystem
  komplettPartner: 3990,    // Anti-Stress-Zimmer komplett: KOKON Partner + Regenerationssystem
  regeneration: 1990,       // Regenerationssystem einzeln (Vergleichspreis)
  einzelteil: 990,          // Oberbett oder Unterbett einzeln — Basis für den Maßaufschlag
  massSchrittCm: 10,        // Maßanfertigung: je angefangene 10 cm über Standard …
  massProzentJeSchritt: 10, // … +10 % des Teilpreises
  tascheZusatz: 35,         // Zusatz-Fastentasche, nur zusammen mit einem Set
  ratenMonate: 72           // Teilzahlung im Checkout: 3 bis 72 Monate, gilt für jede Summe
};

function setPreis() {
  if (wahl.einzel) return PREISE.einzelteil;
  return wahl.personen === 1 ? PREISE.singleSet : PREISE.partnerSet;
}
function komplettPreis() {
  /* ANNAHME (von BETTER³ bestätigen lassen): Beim Einzelteil gibt es
     keinen Bundle-Preis — das Regenerationssystem kommt zum Einzelpreis
     dazu (990 + 1.990 = 2.980). */
  if (wahl.einzel) return PREISE.einzelteil + PREISE.regeneration;
  return wahl.personen === 1 ? PREISE.komplettSingle : PREISE.komplettPartner;
}
/* Was das Regenerationssystem im Bundle kostet: Komplett minus KOKON-Set
   (Single 1.490, Partner 1.000) — statt 1.990 einzeln */
function regenAufpreis() { return komplettPreis() - setPreis(); }
/* ANNAHME (von BETTER³ bestätigen lassen): Die Handy-Fastentasche gehört
   nur zu den Sets — je Person eine (Single 1, Partner 2); zum Einzelteil
   keine. Als Extra bleibt sie auch dort bestellbar. */
function fastentaschen() { return wahl.einzel ? 0 : wahl.personen; }

const GROESSEN_OBERBETT  = ['135 × 200', '155 × 220', '200 × 200', '240 × 220'];
const GROESSEN_UNTERBETT = ['90 × 200', '100 × 200', '140 × 200',
                            '160 × 200', '180 × 200', '200 × 200'];

/* Übliche Vorbelegung je Konstellation */
function vorbelegung() {
  if (wahl.einzel === 'ober') return { ober: ['135 × 200'], unter: [] };
  if (wahl.einzel === 'unter') return { ober: [], unter: ['90 × 200'] };
  if (wahl.personen === 1) return { ober: ['135 × 200'], unter: ['90 × 200'] };
  const ober = wahl.decken === 2
    ? ['135 × 200', '135 × 200']
    : [wahl.matratzen === 2 ? '240 × 220' : '200 × 200'];
  const unter = wahl.matratzen === 2
    ? ['90 × 200', '90 × 200']
    : ['180 × 200'];
  return { ober, unter };
}

/* ---------------------------------------------------------------------
   Zustand: zwei bis drei einfache Fragen ergeben die Konstellation
   --------------------------------------------------------------------- */
const wahl = {
  personen: 1,     // 1 = für mich allein, 2 = für uns zwei
  einzel: null,    // null = Set; 'ober' | 'unter' = nur dieses Teil (990 €)
  matratzen: 2,    // nur bei zwei Personen relevant
  decken: 2,       // nur bei zwei Personen relevant
  elemente: [],    // je Teil: typ 'ober'/'unter', label, modus, groesse, eigenB/L
  oberGetrennt: false,  // Paar-Zudecken einzeln stellen? (Standard: gemeinsam)
  unterGetrennt: false, // Paar-Auflagen einzeln stellen?
  regeneration: false,
  extraTasche: false
};

const wort = (typ) => t(typ === 'ober' ? 'zudecke' : 'auflage');

/* Sind die Groessen eines Typs als Paar gekoppelt? */
function paarGekoppelt(typ) {
  const anzahl = wahl.elemente.filter((el) => el.typ === typ).length;
  if (anzahl < 2) return false;
  return typ === 'ober' ? !wahl.oberGetrennt : !wahl.unterGetrennt;
}

function elementeAufbauen() {
  /* Bereits getroffene Groessenwahlen sichern: Wer die Deckenfrage
     aendert, soll seine Auflagen nicht verlieren. Uebernommen wird nur,
     was bewusst gewaehlt wurde (nicht die Vorbelegung) und nur, solange
     die Stueckzahl dieses Typs gleich bleibt. */
  const alt = { ober: [], unter: [] };
  wahl.elemente.forEach((el) => { alt[el.typ].push(el); });
  const vor = vorbelegung();
  /* Nur der Typ, dessen Stueckzahl sich aendert, wird entkoppelt */
  if (alt.ober.length !== vor.ober.length) wahl.oberGetrennt = false;
  if (alt.unter.length !== vor.unter.length) wahl.unterGetrennt = false;
  const liste = [];
  vor.ober.forEach((groesse, i) => {
    liste.push(elementBauen('ober', i, groesse, vor.ober.length, alt.ober));
  });
  vor.unter.forEach((groesse, i) => {
    liste.push(elementBauen('unter', i, groesse, vor.unter.length, alt.unter));
  });
  wahl.elemente = liste;
}

function elementBauen(typ, i, groesse, anzahl, alte) {
  const einzeln = typ === 'ober'
    ? (wahl.personen === 2 ? t('ihre_gemeinsame_zudecke') : t('ihre_zudecke'))
    : (wahl.personen === 2 ? t('ihre_auflage_durchgehend') : t('ihre_auflage'));
  const el = {
    typ: typ,
    label: anzahl > 1 ? t('person_n', { wort: wort(typ), n: i + 1 }) : einzeln,
    klartext: t(typ === 'ober' ? 'klartext_ober' : 'klartext_unter'),
    standard: groesse,
    modus: 'standard', groesse: groesse, eigenB: '', eigenL: '',
    gewaehlt: false   // true, sobald der Nutzer selbst eine Groesse setzt
  };
  const vorher = alte.length === anzahl ? alte[i] : null;
  if (vorher && vorher.gewaehlt) {
    const erlaubt = typ === 'ober' ? GROESSEN_OBERBETT : GROESSEN_UNTERBETT;
    el.gewaehlt = true;
    el.modus = vorher.modus;
    el.eigenB = vorher.eigenB;
    el.eigenL = vorher.eigenL;
    if (erlaubt.indexOf(vorher.groesse) !== -1) el.groesse = vorher.groesse;
  }
  return el;
}

/* ---------------------------------------------------------------------
   Elemente greifen
   --------------------------------------------------------------------- */
const paarFragen       = document.getElementById('paar-fragen');
const groessenListe    = document.getElementById('groessen-liste');
const zusammenfassung  = document.getElementById('zusammenfassung');
const optRegeneration  = document.getElementById('opt-regeneration');
const optTasche        = document.getElementById('opt-tasche');
const leiste           = document.getElementById('leiste');
const leisteKomponenten = document.getElementById('leiste-komponenten');
const leisteGesamt     = document.getElementById('leiste-gesamt');
const leisteRate       = document.getElementById('leiste-rate');
const leisteWarenkorb  = document.getElementById('leiste-warenkorb');
const kaufFehler       = document.getElementById('kauf-fehler');
const navLeiste        = document.getElementById('nav');

/* Solange der Konfigurator unberuehrt ist, verkauft die Kaufleiste nur
   die Vorbelegung. Sie fuehrt dann in den Konfigurator statt in den Shop. */
let angefasst = false;

function konfiguratorAngefasst() {
  if (angefasst) return;
  angefasst = true;
  aktualisiereLeiste();
}

/* ---------------------------------------------------------------------
   Maßanfertigung — Aufpreisregel laut BETTER³ (2026-09-02):
   "pro 10 cm über der Standardgröße 10 % höherer Preis".
   Auslegung (ANNAHMEN, mit BETTER³ abgestimmt zu halten):
   · Teilpreis = Oberbett bzw. Unterbett einzeln (990 €).
   · Bezugsgröße = die größte Standardgröße des Teils, die in Breite UND
     Länge nicht größer ist als das Wunschmaß; gibt es keine, die
     kleinste Standardgröße.
   · Breite und Länge werden getrennt in angefangenen 10-cm-Schritten
     gezählt und addiert; jeder Schritt +10 %.
   · Untermaß (kleiner als jede Standardgröße) kostet keinen Aufschlag.
   --------------------------------------------------------------------- */
function massDaten(el) {
  if (el.modus !== 'eigen') return null;
  const b = parseInt(el.eigenB, 10), l = parseInt(el.eigenL, 10);
  if (isNaN(b) || isNaN(l)) return null;
  const standards = (el.typ === 'ober' ? GROESSEN_OBERBETT : GROESSEN_UNTERBETT)
    .map((s) => s.split(' × ').map(Number));
  const passend = standards.filter((s) => s[0] <= b && s[1] <= l)
    .sort((x, y) => (y[0] * y[1]) - (x[0] * x[1]));
  const bezug = passend[0] ||
    standards.slice().sort((x, y) => (x[0] * x[1]) - (y[0] * y[1]))[0];
  const schritte =
    Math.ceil(Math.max(0, b - bezug[0]) / PREISE.massSchrittCm) +
    Math.ceil(Math.max(0, l - bezug[1]) / PREISE.massSchrittCm);
  const prozent = schritte * PREISE.massProzentJeSchritt;
  return {
    breite: b, laenge: l, bezug: bezug, schritte: schritte, prozent: prozent,
    aufpreis: Math.round(PREISE.einzelteil * prozent / 100)
  };
}

function massAufpreisGesamt() {
  return wahl.elemente.reduce((summe, el) => {
    const d = massDaten(el);
    return summe + (d ? d.aufpreis : 0);
  }, 0);
}

/* Kurzherleitung für Zusammenfassung und Live-Anzeige */
function massDetail(d) {
  if (!d.schritte) return t('mass_detail_ohne');
  return t('mass_detail', { prozent: d.prozent, schritte: d.schritte, b: d.bezug[0], l: d.bezug[1] });
}

function massLiveText(el, anzahl) {
  const d = massDaten(el);
  if (!d) return t('mass_live_leer');
  if (!d.schritte) return t('mass_live_ohne');
  let s = t('mass_live', { schritte: d.schritte, b: d.bezug[0], l: d.bezug[1], prozent: d.prozent, betrag: formatEuro(d.aufpreis) });
  if (anzahl > 1) s += t('mass_live_mehr', { anzahl: anzahl, betrag: formatEuro(anzahl * d.aufpreis) });
  return s;
}

function groessenText(el) {
  if (el.modus === 'eigen') {
    const b = parseInt(el.eigenB, 10);
    const l = parseInt(el.eigenL, 10);
    if (!isNaN(b) && !isNaN(l)) return t('groesse_mass', { b: b, l: l });
    return t('groesse_mass_leer');
  }
  return t('groesse_cm', { g: el.groesse });
}

/* Einen Groessenblock zeichnen. gruppe = alle Element-Indizes, die
   dieser Block stellt (bei gekoppelten Paaren beide auf einmal). */
function groessenBlock(el, gruppe, titel, klartext, fussLink) {
  const standards = el.typ === 'ober' ? GROESSEN_OBERBETT : GROESSEN_UNTERBETT;
  const daten = ' data-gruppe="' + gruppe.join(',') + '"';
  const chips = standards.map((g) => {
    const aktiv = el.modus === 'standard' && el.groesse === g;
    return '<button type="button" class="groesse-chip' +
    (aktiv ? ' aktiv' : '') + '" aria-pressed="' + (aktiv ? 'true' : 'false') +
    '"' + daten + ' data-groesse="' + g + '">' + t('groesse_cm', { g: g }) +
    (g === el.standard ? '<small>' + t('ueblich') + '</small>' : '') +
    '</button>';
  }).join('');
  const eigen =
    '<span class="sonder-badge">' + t('sonder_badge', { preis: formatEuro(PREISE.einzelteil) }) + '</span>' +
    '<div class="eigene-felder">' +
    '<label>' + t('breite_cm') + '<input type="number" min="60" max="300" inputmode="numeric" placeholder="' + t('ph_breite') + '" value="' + el.eigenB + '"' + daten + ' data-feld="eigenB"></label>' +
    '<label>' + t('laenge_cm') + '<input type="number" min="140" max="260" inputmode="numeric" placeholder="' + t('ph_laenge') + '" value="' + el.eigenL + '"' + daten + ' data-feld="eigenL"></label>' +
    '</div>' +
    '<p class="mass-live">' + massLiveText(el, gruppe.length) + '</p>' +
    '<p class="mass-hinweis">' + t('mass_hinweis') + '</p>';
  return '<div class="groessen-block" data-gruppe="' + gruppe.join(',') +
    '" data-typ="' + el.typ + '" data-idx="' +
    (gruppe.length > 1 ? '' : gruppe[0] - wahl.elemente.findIndex((e) => e.typ === el.typ)) + '">' +
    '<div class="groessen-kopf"><h4>' + titel + '</h4><span class="klartext">' + klartext + '</span></div>' +
    '<p class="groessen-hilfe">' + t(el.typ === 'ober' ? 'hilfe_ober' : 'hilfe_unter') + '</p>' +
    '<div class="modus-toggle" role="group" aria-label="' + t('modus_aria') + '">' +
    '<button type="button" class="' + (el.modus === 'standard' ? 'aktiv' : '') + '" aria-pressed="' + (el.modus === 'standard' ? 'true' : 'false') + '"' + daten + ' data-modus="standard">' + t('modus_standard') + '</button>' +
    '<button type="button" class="' + (el.modus === 'eigen' ? 'aktiv' : '') + '" aria-pressed="' + (el.modus === 'eigen' ? 'true' : 'false') + '"' + daten + ' data-modus="eigen">' + t('modus_eigen') + '</button>' +
    '</div>' +
    (el.modus === 'standard' ? '<div class="chip-gruppe">' + chips + '</div>' : eigen) +
    (fussLink || '') +
    '</div>';
}

/* Das Neuzeichnen ersetzt das gesamte Markup — ohne Nachfuehren landet
   der Tastaturfokus auf <body>. Wir merken uns die Signatur des aktiven
   Bedienelements und setzen den Fokus danach auf sein Gegenstueck. */
function renderGroessenMitFokus() {
  const aktiv = document.activeElement;
  let signatur = '';
  if (aktiv && groessenListe.contains(aktiv)) {
    const d = aktiv.dataset;
    if (d.gruppe) signatur += '[data-gruppe="' + d.gruppe + '"]';
    if (d.modus) signatur += '[data-modus="' + d.modus + '"]';
    if (d.groesse) signatur += '[data-groesse="' + d.groesse + '"]';
    if (d.feld) signatur += '[data-feld="' + d.feld + '"]';
    if (d.trennen || d.koppeln) signatur = '.paar-link';
  }
  renderGroessen();
  if (!signatur) return;
  const neu = groessenListe.querySelector(signatur) ||
              groessenListe.querySelector('.paar-link');
  if (neu) neu.focus();
}

function renderGroessen() {
  let html = '';
  ['ober', 'unter'].forEach((typ) => {
    const indizes = [];
    wahl.elemente.forEach((el, i) => { if (el.typ === typ) indizes.push(i); });
    if (!indizes.length) return;
    const erster = wahl.elemente[indizes[0]];
    const wortZwei = t(typ === 'ober' ? 'ihre_zudecken' : 'ihre_auflagen');
    if (indizes.length === 1) {
      html += groessenBlock(erster, indizes, erster.label, erster.klartext, '');
    } else if (paarGekoppelt(typ)) {
      /* EIN Block stellt beide — der Normalfall bleibt einfach */
      html += groessenBlock(erster, indizes, wortZwei,
        erster.klartext + t('zwei_stueck'),
        '<button type="button" class="paar-link" data-trennen="' + typ + '">' +
        t('person2_andere') + '</button>');
    } else {
      html += groessenBlock(erster, [indizes[0]], t('person_n', { wort: wort(typ), n: 1 }),
        erster.klartext, '');
      html += groessenBlock(wahl.elemente[indizes[1]], [indizes[1]],
        t('person_n', { wort: wort(typ), n: 2 }), wahl.elemente[indizes[1]].klartext,
        '<button type="button" class="paar-link" data-koppeln="' + typ + '">' +
        t('gleiche_groesse') + '</button>');
    }
  });
  groessenListe.innerHTML = html;
}

/* ---------------------------------------------------------------------
   Preis, Zusammenfassung, Leiste
   --------------------------------------------------------------------- */
function berechneGesamt() {
  /* Mit Regenerationssystem gilt der Komplett-Preis (Bundle), sonst das
     KOKON-Set; dazu Maßaufschläge und die Zusatztasche */
  let gesamt = wahl.regeneration ? komplettPreis() : setPreis();
  gesamt += massAufpreisGesamt();
  if (wahl.extraTasche) gesamt += PREISE.tascheZusatz;
  return gesamt;
}

/* Maßaufschlag-Zeilen für die Zusammenfassung; gekoppelte Paare als eine
   Zeile mit "2 ×" */
function massZeilen() {
  const zeilen = [];
  ['ober', 'unter'].forEach((typ) => {
    const els = wahl.elemente.filter((el) => el.typ === typ);
    if (els.length === 2 && paarGekoppelt(typ)) {
      const d = massDaten(els[0]);
      if (d) zeilen.push({ name: t('mass_zeile_2', { wort: wort(typ) }), detail: massDetail(d), betrag: 2 * d.aufpreis });
    } else {
      els.forEach((el, i) => {
        const d = massDaten(el);
        if (d) zeilen.push({
          name: t('mass_zeile', { wort: wort(typ) }) + (els.length > 1 ? t('person_suffix', { n: i + 1 }) : ''),
          detail: massDetail(d), betrag: d.aufpreis
        });
      });
    }
  });
  return zeilen;
}

/* Extra-Karte: Bundle-Aufpreis des Regenerationssystems je Set */
function aktualisiereExtraPreise() {
  const el = document.getElementById('regen-preis');
  if (!el) return;
  el.innerHTML = '+ ' + formatEuro(regenAufpreis()) + ' €' +
    '<small class="preis-hinweis">' +
    (wahl.einzel
      ? t('regen_einzel_hinweis')
      : t('regen_komplett_hinweis', { preis: formatEuro(PREISE.regeneration) })) +
    '</small>';
}

function formatEuro(betrag) {
  return betrag.toLocaleString(ZAHL_LOCALE);
}

function renderZusammenfassung() {
  const gesamt = berechneGesamt();
  const rate = Math.ceil(gesamt / PREISE.ratenMonate);
  let s = '<p class="zsm-titel">' + t('zsm_titel') + '</p>';
  const artName = wahl.einzel ? t('zsm_einzelteil') : (wahl.personen === 1 ? t('zsm_allein') : t('zsm_zwei'));
  const artWert = wahl.einzel
    ? (wahl.einzel === 'ober' ? t('zsm_zudecke_einzeln') : t('zsm_auflage_einzeln'))
    : (wahl.personen === 1 ? t('zsm_single_set') : t('zsm_partner_set'));
  s += '<div class="zsm-zeile"><span>' + artName + '</span><span class="zsm-wert">' + artWert + '</span></div>';
  zeilenFuerElemente().forEach((z) => {
    s += '<div class="zsm-zeile"><span>' + z.name + '</span><span class="zsm-wert">' + z.wert + '</span></div>';
  });
  s += '<div class="zsm-zeile"><span>' + t('zsm_tasche') + '</span><span class="zsm-wert">' +
       (fastentaschen() ? t('zsm_tasche_im_set', { n: fastentaschen() }) : t('zsm_tasche_nur_sets')) + '</span></div>';
  s += '<div class="zsm-zeile"><span>' + (wahl.einzel ? t('zsm_teilpreis') : t('zsm_set')) + '</span><span class="zsm-wert">' + formatEuro(setPreis()) + ' €</span></div>';
  if (wahl.regeneration) {
    const hinweis = wahl.einzel
      ? t('zsm_regen_einzel')
      : t('zsm_regen_komplett', { preis: formatEuro(PREISE.regeneration) });
    s += '<div class="zsm-zeile"><span>' + t('zsm_regen') + '<small class="zsm-hinweis">' + hinweis + '</small></span><span class="zsm-wert">+ ' + formatEuro(regenAufpreis()) + ' €</span></div>';
  }
  massZeilen().forEach((m) => {
    s += '<div class="zsm-zeile"><span>' + m.name + '<small class="zsm-hinweis">' + m.detail + '</small></span><span class="zsm-wert">' +
         (m.betrag ? '+ ' + formatEuro(m.betrag) + ' €' : t('zsm_inklusive')) + '</span></div>';
  });
  if (wahl.extraTasche) {
    s += '<div class="zsm-zeile"><span>' + t('zsm_tasche_extra') + '</span><span class="zsm-wert">+ ' + formatEuro(PREISE.tascheZusatz) + ' €</span></div>';
  }
  s += '<div class="zsm-gesamt"><span class="mwst">' + t('zsm_gesamt_html') + '</span><span class="betrag">' + formatEuro(gesamt) + ' €</span></div>';
  s += '<p class="zsm-rate">' + t('zsm_rate', { rate: rate }) + '</p>';
  zusammenfassung.innerHTML = s;
}

/* Elementzeilen für Zusammenfassung und Leiste: identische Paare
   werden zu einer "2 ×"-Zeile gebündelt — kürzer und klarer */
function zeilenFuerElemente() {
  const zeilen = [];
  ['ober', 'unter'].forEach((typ) => {
    const els = wahl.elemente.filter((el) => el.typ === typ);
    if (!els.length) return;
    if (els.length === 2 && paarGekoppelt(typ)) {
      zeilen.push({ name: t('zwei_mal', { wort: wort(typ) }), wert: groessenText(els[0]),
                    klartext: t('zwei_mal', { wort: els[0].klartext }) });
    } else {
      els.forEach((el, i) => {
        zeilen.push({ name: els.length > 1 ? t('person_n', { wort: wort(typ), n: i + 1 }) : el.label,
                      wert: groessenText(el), klartext: el.klartext });
      });
    }
  });
  return zeilen;
}

function komponentenListe() {
  const massWort = t('groesse_mass', { b: '', l: '' }).replace(/^[\s×]+/, ''); // z. B. "cm · Maßanfertigung"
  const teile = zeilenFuerElemente().map((z) =>
    z.klartext + ' ' + z.wert.replace(massWort, 'cm' + t('komp_mass')));
  if (fastentaschen()) teile.push(t('komp_tasche_set', { n: fastentaschen() }));
  if (wahl.extraTasche) teile.push(t('komp_tasche_extra'));
  if (wahl.regeneration) teile.push(t('zsm_regen'));
  return teile;
}

function aktualisiereLeiste() {
  const gesamt = berechneGesamt();
  leisteKomponenten.textContent = komponentenListe().join('  ·  ');
  leisteGesamt.textContent = formatEuro(gesamt) + ' €';
  leisteRate.textContent = t('leiste_rate', { rate: Math.ceil(gesamt / PREISE.ratenMonate) });
  leisteWarenkorb.textContent = angefasst
    ? t('in_warenkorb')
    : t('jetzt_zusammenstellen');
}

/* ---------------------------------------------------------------------
   LIVE-BÜHNE: der Stapel spiegelt die Auswahl, leicht geöffnet,
   und erklärt auf Klick oder Berührung jede Ebene.
   --------------------------------------------------------------------- */
/* Bühnen-Elemente: fünf Illustrationen, vier Marker, eine Pad-Karte */
const buehnenBilder = {
  s1: document.getElementById('bild-s1'),
  s2: document.getElementById('bild-s2'),
  s3: document.getElementById('bild-s3'),
  s4: document.getElementById('bild-s4'),
  s5: document.getElementById('bild-s5')
};
const markerElemente = {
  ober: document.getElementById('marker-ober'),
  unter: document.getElementById('marker-unter'),
  tasche: document.getElementById('marker-tasche'),
  matratze: document.getElementById('marker-matratze')
};
const padKarte = document.getElementById('pad-karte');
const padKarteText = document.getElementById('pad-karte-text');
const stBadge = document.getElementById('st-badge');
const erklaerung = document.getElementById('buehne-erklaerung');
const erklTitel = document.getElementById('erkl-titel');
const erklText = document.getElementById('erkl-text');
const fokusPunkte = document.getElementById('fokus-punkte');

/* Erklärtexte: Alltagssprache zuerst, Produktname in Klammern.
   Inhalte ausschließlich aus dem freigegebenen Material der Vorseite. */
function erklaerungFuer(typ) {
  const k = typ || 'ueberblick';
  return { titel: t('erkl_' + k + '_titel'), text: t('erkl_' + k + '_text') };
}

let fokusTyp = null; // null = noch nie gesetzt (Start), '' = Überblick
let fokusIdx = null; // null = alle Teile des Typs gemeint

/* Welche Konstellation zeigt das Bild? */
function situationsId() {
  if (wahl.personen === 1) return 's1';
  if (wahl.matratzen === 2 && wahl.decken === 2) return 's2';
  if (wahl.matratzen === 1 && wahl.decken === 2) return 's3';
  if (wahl.matratzen === 2 && wahl.decken === 1) return 's4';
  return 's5';
}

/* Marker-Positionen je Konstellation (Prozent der Bühnenfläche, x/y).
   Die Fastentasche liegt in allen fünf Bildern auf dem Nachttisch rechts
   (Korrektur BETTER³, 2026-09-02). */
const MARKER_POS = {
  s1: { ober: [46, 38], unter: [44, 62], tasche: [84, 60], matratze: [61, 79] },
  s2: { ober: [38, 32], unter: [63, 57], tasche: [84, 60], matratze: [61, 79] },
  s3: { ober: [38, 32], unter: [63, 57], tasche: [84, 60], matratze: [61, 79] },
  s4: { ober: [44, 32], unter: [31, 56], tasche: [84, 60], matratze: [61, 79] },
  s5: { ober: [44, 32], unter: [31, 56], tasche: [84, 60], matratze: [61, 79] }
};


function aktualisiereBuehne() {
  const id = situationsId();

  /* Bildwechsel: nur die aktive Konstellation ist sichtbar */
  Object.keys(buehnenBilder).forEach((key) => {
    buehnenBilder[key].classList.toggle('an', key === id);
  });

  /* Marker an die Bildstellen der aktiven Konstellation setzen */
  Object.keys(markerElemente).forEach((typ) => {
    const pos = MARKER_POS[id][typ];
    const el = markerElemente[typ];
    el.style.left = pos[0] + '%';
    el.style.top = pos[1] + '%';
    el.classList.toggle('aktiv', fokusTyp === typ);
    el.setAttribute('aria-pressed', fokusTyp === typ ? 'true' : 'false');
    /* Beim Einzelteil treten die nicht bestellten Ebenen zurück */
    el.classList.toggle('gedimmt', !!wahl.einzel && typ !== wahl.einzel && typ !== 'matratze');
  });

  /* Produktzeile: gewählt = voll, nur im Fokus = hervorgehoben, sonst gedimmt */
  const gewaehlt = wahl.regeneration;
  const anzeigen = gewaehlt || fokusTyp === 'regen';
  padKarte.classList.toggle('an', anzeigen);
  padKarte.classList.toggle('vorschau', anzeigen && !gewaehlt);
  setzePadText(gewaehlt);
}

/* Die Bildkarte ist auf Telefonen nur gut 110 px breit — dort steht die
   Kurzform, den vollen Namen tragen Badge und Erklaertext darunter. */
function setzePadText(gewaehlt) {
  const knapp = window.matchMedia('(max-width: 560px)').matches;
  padKarteText.textContent = gewaehlt
    ? t('pad_dazugelegt')
    : (knapp ? t('pad_nicht_gewaehlt_kurz') : t('pad_nicht_gewaehlt'));
}

/* Fokus setzen: hebt die Ebene an, dimmt den Rest, tauscht den Text */
let erklTimer = null;

function setzeFokus(typ, idx) {
  if (typ === 'regen' && !wahl.regeneration) {
    /* Erklärt das Extra auch, wenn es (noch) nicht gewählt ist */
    idx = null;
  }
  if (fokusTyp === typ && fokusIdx === (idx === undefined ? null : idx)) return;
  fokusTyp = typ;
  fokusIdx = idx === undefined ? null : idx;
  aktualisiereBuehne();

  const eintrag = erklaerungFuer(typ);
  if (reduzierteBewegung) {
    erklTitel.textContent = eintrag.titel;
    erklText.textContent = eintrag.text;
  } else {
    erklaerung.classList.add('wechselt');
    clearTimeout(erklTimer);
    erklTimer = setTimeout(() => {
      erklTitel.textContent = eintrag.titel;
      erklText.textContent = eintrag.text;
      erklaerung.classList.remove('wechselt');
    }, 180);
  }

  Array.from(fokusPunkte.querySelectorAll('button')).forEach((b) => {
    const aktiv = b.dataset.ziel === typ;
    b.classList.toggle('aktiv', aktiv);
    b.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
  });
  aktualisiereBadge();
}

/* Live-Badge: benennt das fokussierte Teil samt gewählter Größe */
function aktualisiereBadge() {
  let text = '';
  if (fokusTyp === 'ober' || fokusTyp === 'unter') {
    const els = wahl.elemente.filter((el) => el.typ === fokusTyp);
    const w = wort(fokusTyp);
    if (!els.length) {
      /* Einzelteil: die andere Ebene ist nicht Teil der Bestellung */
      text = t('badge_nicht_bestellt', { wort: w });
    } else if (els.length === 1) {
      text = w + ' · ' + groessenText(els[0]);
    } else if (paarGekoppelt(fokusTyp)) {
      text = t('zwei_mal', { wort: w }) + ' · ' + groessenText(els[0]);
    } else if (fokusIdx !== null && els[fokusIdx]) {
      text = w + t('badge_person', { n: fokusIdx + 1 }) + groessenText(els[fokusIdx]);
    } else {
      text = w + t('badge_p1') + groessenText(els[0]) +
             t('badge_p2') + groessenText(els[1]);
    }
  } else if (fokusTyp === 'tasche') {
    text = fastentaschen()
      ? t(wahl.extraTasche ? 'badge_tasche_set_extra' : 'badge_tasche_set', { n: fastentaschen() })
      : t(wahl.extraTasche ? 'badge_tasche_nur_sets_extra' : 'badge_tasche_nur_sets');
  } else if (fokusTyp === 'regen') {
    text = wahl.regeneration ? t('badge_regen_dazu') : t('badge_regen_extra');
  }
  stBadge.textContent = text;
  stBadge.classList.toggle('an', !!text);
}

/* Klick auf einen Nummern-Marker oder die Pad-Karte im Bild */
document.getElementById('buehne-szene').addEventListener('click', (ev) => {
  const ziel = ev.target.closest('[data-fokus]');
  if (!ziel) return;
  setzeFokus(ziel.dataset.fokus);
});

/* Die Produktzeile des Regenerationssystems erklärt sich per Klick oder Taste */
padKarte.addEventListener('click', () => setzeFokus('regen'));
padKarte.addEventListener('keydown', (ev) => {
  if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); setzeFokus('regen'); }
});

/* Fokus-Knöpfe unter der Bühne */
fokusPunkte.addEventListener('click', (ev) => {
  const knopf = ev.target.closest('button');
  if (knopf) setzeFokus(knopf.dataset.ziel);
});

/* Beim Arbeiten in einem Größenblock hebt sich das passende Teil */
groessenListe.addEventListener('pointerover', (ev) => {
  const blockEl = ev.target.closest('.groessen-block');
  if (!blockEl) return;
  const roh = parseInt(blockEl.dataset.idx, 10);
  setzeFokus(blockEl.dataset.typ, isNaN(roh) ? undefined : roh);
});

/* ---------------------------------------------------------------------
   Alles anwenden
   --------------------------------------------------------------------- */
function aktualisiereAlles() {
  /* Ein offener Massfehler loest sich auf, sobald die Werte passen */
  if (kaufFehler && !kaufFehler.hidden && !fehlendeMasse().length) {
    kaufFehler.hidden = true;
    markiereFehlende([]);
  }
  renderZusammenfassung();
  aktualisiereExtraPreise();
  aktualisiereBuehne();
  aktualisiereLeiste();
  aktualisiereBadge();
}

/* ---------------------------------------------------------------------
   Übergabe an den Shop.
   konfigurationDaten() liefert die komplette Auswahl als Objekt; der Hook
   window.kokonUebergabe (Section) bildet sie auf Shopify-Varianten ab und
   legt sie per /cart/add.js in den Warenkorb.
   ===================================================================== */
function konfigurationDaten() {
  return {
    personen: wahl.personen,
    matratzen: wahl.personen === 1 ? 1 : wahl.matratzen,
    decken: wahl.personen === 1 ? 1 : wahl.decken,
    elemente: wahl.elemente.map((el) => {
      const d = massDaten(el);
      return {
        typ: el.typ === 'ober' ? 'oberbett' : 'unterbett',
        label: el.label,
        modus: el.modus,
        groesse: groessenText(el),
        /* strukturierte Maße fuer das Shopify-Mapping */
        breiteCm: d ? d.breite : null,
        laengeCm: d ? d.laenge : null,
        massAufpreisEuro: d ? d.aufpreis : 0
      };
    }),
    einzelteil: wahl.einzel,               // null = Set, 'ober'/'unter' = nur dieses Teil
    fastentaschenImSet: fastentaschen(),   // je Person eine (BETTER³, 2026-09-02); Einzelteil: 0 (Annahme)
    extraTasche: wahl.extraTasche,
    regenerationssystem: wahl.regeneration,
    komplettSet: wahl.regeneration,        // true = Komplett-Preis statt KOKON-Set
    setEuro: wahl.regeneration ? komplettPreis() : setPreis(),
    massAufpreisEuro: massAufpreisGesamt(),
    gesamtEuro: berechneGesamt(),
    sprache: SPRACHE
  };
}

/* Massanfertigung ohne Masse darf nicht in den Shop wandern: Der
   Aufpreis ist berechnet, aber die Fertigungsdaten fehlen. */
function fehlendeMasse() {
  return wahl.elemente.filter((el) => {
    if (el.modus !== 'eigen') return false;
    const b = parseInt(el.eigenB, 10);
    const l = parseInt(el.eigenL, 10);
    return isNaN(b) || isNaN(l) ||
           b < 60 || b > 300 || l < 140 || l > 260;
  });
}

/* Betroffene Bloecke markieren und den ersten davon zurueckgeben */
function markiereFehlende(fehlt) {
  const offen = fehlt.map((el) => wahl.elemente.indexOf(el));
  let erster = null;
  Array.from(groessenListe.querySelectorAll('.groessen-block')).forEach((block) => {
    const gruppe = (block.dataset.gruppe || '').split(',').map(Number);
    const betroffen = gruppe.some((n) => offen.indexOf(n) !== -1);
    block.classList.toggle('fehlt', betroffen);
    if (betroffen && !erster) erster = block;
  });
  return erster;
}

function massePruefen() {
  const fehlt = fehlendeMasse();
  if (!fehlt.length) {
    markiereFehlende([]);
    kaufFehler.hidden = true;
    return true;
  }
  kaufFehler.textContent = fehlt.length === 1 ? t('fehler_masse_1') : t('fehler_masse_n');
  kaufFehler.hidden = false;
  const block = markiereFehlende(fehlt);
  if (block) {
    block.scrollIntoView({
      behavior: reduzierteBewegung ? 'auto' : 'smooth', block: 'center'
    });
    const feld = block.querySelector('input[data-feld]');
    if (feld) setTimeout(() => feld.focus(), reduzierteBewegung ? 0 : 420);
  }
  return false;
}

function warenkorbUebergabe() {
  if (!massePruefen()) return;
  const daten = konfigurationDaten();
  /* EINBAU-HOOK: Das Theme definiert window.kokonUebergabe (Section
     kokon-shop.liquid) — Mapping auf Shopify-Varianten und Warenkorb-API.
     Ohne Hook (z. B. lokale Vorschau) bleibt die URL-Übergabe. */
  if (typeof window.kokonUebergabe === 'function') {
    window.kokonUebergabe(daten);
    return;
  }
  const json = JSON.stringify(daten);
  const kodiert = btoa(unescape(encodeURIComponent(json)));
  window.open('https://www.betterhochdrei.store/#kokon=' + kodiert,
              '_blank', 'noopener');
}

document.getElementById('warenkorb-knopf').addEventListener('click', warenkorbUebergabe);

leisteWarenkorb.addEventListener('click', () => {
  /* Vor der ersten Auswahl fuehrt die Leiste in den Konfigurator */
  if (!angefasst) {
    document.getElementById('konfigurator').scrollIntoView({
      behavior: reduzierteBewegung ? 'auto' : 'smooth', block: 'start'
    });
    return;
  }
  warenkorbUebergabe();
});

/* ---------------------------------------------------------------------
   Ereignisse: Fragen, Größen, Extras
   --------------------------------------------------------------------- */
function frageGeaendert() {
  paarFragen.hidden = wahl.personen !== 2;
  elementeAufbauen();
  renderGroessen();
  aktualisiereAlles();
}

document.querySelectorAll('input[name="personen"]').forEach((eingabe) => {
  eingabe.addEventListener('change', konfiguratorAngefasst);
  eingabe.addEventListener('change', () => {
    if (eingabe.value === 'ober' || eingabe.value === 'unter') {
      wahl.personen = 1;          // Einzelteil: eine Person, ein Teil
      wahl.einzel = eingabe.value;
    } else {
      wahl.personen = Number(eingabe.value);
      wahl.einzel = null;
    }
    frageGeaendert();
    setzeFokus(wahl.einzel || '');
  });
});


document.querySelectorAll('input[name="matratzen"]').forEach((eingabe) => {
  eingabe.addEventListener('change', konfiguratorAngefasst);
  eingabe.addEventListener('change', () => {
    wahl.matratzen = Number(eingabe.value);
    frageGeaendert();
    setzeFokus('unter');
  });
});

document.querySelectorAll('input[name="decken"]').forEach((eingabe) => {
  eingabe.addEventListener('change', konfiguratorAngefasst);
  eingabe.addEventListener('change', () => {
    wahl.decken = Number(eingabe.value);
    frageGeaendert();
    setzeFokus('ober');
  });
});

function gruppenElemente(knoten) {
  return (knoten.dataset.gruppe || '').split(',')
    .map((n) => wahl.elemente[Number(n)]).filter(Boolean);
}

groessenListe.addEventListener('click', (ev) => {
  const knopf = ev.target.closest('button');
  if (!knopf) return;
  if (knopf.dataset.trennen) {
    if (knopf.dataset.trennen === 'ober') wahl.oberGetrennt = true;
    else wahl.unterGetrennt = true;
    renderGroessenMitFokus();
    aktualisiereAlles();
    return;
  }
  if (knopf.dataset.koppeln) {
    const typ = knopf.dataset.koppeln;
    if (typ === 'ober') wahl.oberGetrennt = false; else wahl.unterGetrennt = false;
    /* Beim Zusammenlegen übernimmt Person 2 die Wahl von Person 1 */
    const els = wahl.elemente.filter((el) => el.typ === typ);
    if (els.length === 2) {
      els[1].modus = els[0].modus;
      els[1].groesse = els[0].groesse;
      els[1].eigenB = els[0].eigenB;
      els[1].eigenL = els[0].eigenL;
    }
    renderGroessenMitFokus();
    aktualisiereAlles();
    return;
  }
  const els = gruppenElemente(knopf);
  if (!els.length) return;
  if (knopf.dataset.modus) {
    if (els[0].modus === knopf.dataset.modus) return;
    els.forEach((el) => { el.modus = knopf.dataset.modus; el.gewaehlt = true; });
    renderGroessenMitFokus();
  } else if (knopf.dataset.groesse) {
    els.forEach((el) => {
      el.groesse = knopf.dataset.groesse; el.modus = 'standard'; el.gewaehlt = true;
    });
    renderGroessenMitFokus();
  }
  konfiguratorAngefasst();
  aktualisiereAlles();
});

groessenListe.addEventListener('input', (ev) => {
  const feld = ev.target.closest('input[data-feld]');
  if (!feld) return;
  const els = gruppenElemente(feld);
  els.forEach((el) => {
    el[feld.dataset.feld] = feld.value; el.gewaehlt = true;
  });
  /* Aufpreis direkt unter den Feldern nachfuehren, ohne den Block neu
     zu zeichnen (das wuerde den Fokus aus dem Eingabefeld werfen) */
  const live = feld.closest('.groessen-block');
  if (live && els.length) {
    const ziel = live.querySelector('.mass-live');
    if (ziel) ziel.textContent = massLiveText(els[0], els.length);
  }
  konfiguratorAngefasst();
  aktualisiereAlles();
});

optRegeneration.addEventListener('change', () => {
  konfiguratorAngefasst();
  wahl.regeneration = optRegeneration.checked;
  aktualisiereAlles();
  setzeFokus('regen');
});

optTasche.addEventListener('change', () => {
  konfiguratorAngefasst();
  wahl.extraTasche = optTasche.checked;
  aktualisiereAlles();
  setzeFokus('tasche');
});

/* ---------------------------------------------------------------------
   Scroll-Verhalten: feste Nav, Leiste ab dem Konfigurator
   --------------------------------------------------------------------- */
const konfigurator = document.getElementById('konfigurator');

function beiScroll() {
  const y = window.scrollY;
  if (navLeiste) navLeiste.classList.toggle('fest', y > 40);
  const konfigOben = konfigurator.getBoundingClientRect().top + y;
  leiste.classList.toggle('sichtbar', y > konfigOben - window.innerHeight * 0.5);
}

addEventListener('scroll', beiScroll, { passive: true });
addEventListener('resize', () => {
  beiScroll();
  setzePadText(wahl.regeneration);   // Kurz-/Langform beim Drehen
}, { passive: true });

/* ---------------------------------------------------------------------
   Wirkzahlen: zählen beim ersten Sichtbarwerden hoch
   --------------------------------------------------------------------- */
(function () {
  const zahlen = Array.from(document.querySelectorAll('[data-zahl]'));
  if (!zahlen.length) return;
  if (reduzierteBewegung || !('IntersectionObserver' in window)) {
    zahlen.forEach((el) => { el.textContent = el.dataset.zahl; });
    return;
  }
  const io = new IntersectionObserver((eintraege) => {
    eintraege.forEach((eintrag) => {
      if (!eintrag.isIntersecting) return;
      io.unobserve(eintrag.target);
      const ziel = Number(eintrag.target.dataset.zahl);
      const start = performance.now();
      const DAUER = 1100; // ms
      requestAnimationFrame(function tick(jetzt) {
        const t = klemme((jetzt - start) / DAUER, 0, 1);
        eintrag.target.textContent = Math.round(ziel * (t * (2 - t)));
        if (t < 1) requestAnimationFrame(tick);
      });
    });
  }, { threshold: 0.4 });
  zahlen.forEach((el) => io.observe(el));
})();

/* ---------------------------------------------------------------------
   Start
   --------------------------------------------------------------------- */
elementeAufbauen();
renderGroessen();
aktualisiereAlles();
setzeFokus('');
beiScroll();
})();
